import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DialogLegalDisclaimerComponent } from '@cigna/chcp/shell/ui';

import { DialogEvernorthHelpPublicComponent } from '../dialog-evernorth-help-public/dialog-evernorth-help-public.component';
import { DialogEvernorthHelpSecureComponent } from '../dialog-evernorth-help-secure/dialog-evernorth-help-secure.component';

@Component({
  selector: 'cigna-evernorth-footer',
  templateUrl: './evernorth-footer.component.html',
  styleUrls: ['./evernorth-footer.component.scss'],
})
export class EvernorthFooterComponent {
  @Input() isLoggedIn = false;

  currentYear: string = new Date().getFullYear().toString();

  constructor(private dialog: MatDialog) {}

  openSiteHelpModal() {
    if (this.isLoggedIn) {
      this.dialog.open(DialogEvernorthHelpSecureComponent, {
        autoFocus: false,
        width: '950px',
      });
    } else {
      this.dialog.open(DialogEvernorthHelpPublicComponent, {
        autoFocus: false,
        width: '950px',
      });
    }
  }

  openLegalDisclaimerModal() {
    this.dialog.open(DialogLegalDisclaimerComponent, {
      autoFocus: false,
      width: '800px',
    });
  }
}
